import { ADMIN_LOAD_POSTS_LIMIT, POST_SOURCE_FEED, POST_SOURCE_ORGANIC, POST_STATUS_DRAFT, POST_VARIATION_APPROVED, POST_VARIATION_PENDING_APPROVAL, POST_VARIATION_REJECTED } from "../constants"

export async function loadAdminPostsPageData({ request }) {
  const url = new URL(request.url)
  const orgID = url.searchParams.get('orgID')
  const status = url.searchParams.get('status') || "PUBLISHED"
  let postStatus = status
  let variationStatus = POST_VARIATION_APPROVED
  if (status === POST_VARIATION_PENDING_APPROVAL || status === POST_VARIATION_REJECTED) {
    variationStatus = status
    postStatus = "PUBLISHED"
  }

  let channelIDs = url.searchParams.getAll('channelIDs')
  let campaignIDs = url.searchParams.getAll('campaignIDs')
  let source
  if (status === POST_SOURCE_FEED) {
    source = POST_SOURCE_FEED
    postStatus = POST_STATUS_DRAFT
    channelIDs = []
    campaignIDs = []
  } else if (status === POST_STATUS_DRAFT) {
    source = POST_SOURCE_ORGANIC
    variationStatus = undefined
  }

  const queryParams = new URLSearchParams({ userType: "admin", status: postStatus, limit: ADMIN_LOAD_POSTS_LIMIT })
  channelIDs = channelIDs.map(id => parseInt(id)).filter(id => Number.isInteger(id))
  if (channelIDs.length > 0) {
    queryParams.append("channelIDs", channelIDs.join(","))
  }
  campaignIDs = campaignIDs.map(id => parseInt(id)).filter(id => Number.isInteger(id))
  if (campaignIDs.length > 0) {
    queryParams.append("campaignIDs", campaignIDs.join(","))
  }
  if (source) {
    queryParams.append("source", source)
  }
  if (variationStatus) {
    queryParams.append("postVariationStatus", variationStatus)
  }

  const superUserQueryParams = new URLSearchParams()
  if (orgID) {
    queryParams.append("orgID", orgID)
    superUserQueryParams.append("orgID", orgID)
  }

  const postsRes = await fetch(`/api/posts?${queryParams.toString()}`)

  const { Data: postsData } = await postsRes.json()

  return { posts: postsData.Posts, counts: postsData.Counts, status, filters: { channelIDs, campaignIDs }, source }
}
